import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LargeTextModal from "../SharedComponents/GeneralModals/Components/LargeTextModal";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UpdateLargeTextModalData } from "../SharedComponents/GeneralModals/Store";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import IconSvg from "../SharedComponents/IconSvg";
import ApiHelper from "../../Helpers/ApiHelper";

const LandingPageFooter = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [selectedKvkkText, setSelectedKvkkText] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const isLargeTextModalShown = useSelector((state) => state.generalModals.largeTextModalData.isShown);
  const textMap = {
    acik_riza_metni: "/Kvkk-Files/ttAcikRizaMetni.html",
    aydinlatma_metinleri: "/Kvkk-Files/ttAydinlatmaMetinleri.html",
    bilgi_guvenligi_politikalari: "/Kvkk-Files/ttBilgiGuvenligiPolitikalari.html",
    gizlilik_ve_cerezler: "/Kvkk-Files/ttGizlilikVeCerezler.html",
    sozlesmeler: "/Kvkk-Files/ttSozlesmeler.html",
    veri_sahibi_haklari: "/Kvkk-Files/ttVeriSahibiHaklari.html",
  };

  useEffect(() => {
    const filePath = textMap[selectedKvkkText];

    if (filePath) {
      fetch(filePath)
        .then((res) => res.text())
        .then((data) => setHtmlContent(data))
        .then(dispatch(UpdateLargeTextModalData({ isShown: true })));
    }
  }, [selectedKvkkText]);

  useEffect(() => {
    if (!isLargeTextModalShown) {
      setSelectedKvkkText("");
    }
  }, [isLargeTextModalShown]);

  const navigate = useNavigate();
  return (
    <>
      <LargeTextModal> {htmlContent}</LargeTextModal>
      <Row>
        <Col>
          <Row>
            <Col xs={12} md={12} xxl={3} className={"align-content-center"}>
              <Row className={"justify-content-center mt-5"}>
                <Col xs={"auto"} className={"align-content-center"}>
                  <IconSvg icon="cp-logo" height={60} width={60} />
                </Col>
                <Col xs={"auto"} className={"text-48 lh-1 text-color-primary fw-medium  "}>
                  Cus-Pro
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={12} xxl={8} className={"gilroy-regular text-color-gray-dark"}>
              <Row className={"my-5 text-20 text-center text-xxl-start justify-content-evenly"}>
                <Col xs={12} md={4} xxl={"auto"}>
                  <Row className={"text-24 mb-3 mt-5 gilroy-bold"}>
                    <Col>{t("landing.footer.siteMap")}</Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/");
                      }}
                    >
                      {t("landing.nav.home")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/aboutUs");
                      }}
                    >
                      {t("landing.nav.aboutUs")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/skillAnalytics");
                      }}
                    >
                      {t("landing.nav.skillAnalytics")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/skillManagement");
                      }}
                    >
                      {t("landing.nav.skillManagement")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/individualServices");
                      }}
                    >
                      {t("landing.nav.careerAnalytics")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/individualServices");
                      }}
                    >
                      {t("landing.nav.careerConsulting")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        navigate("/assessmentLibrary");
                      }}
                    >
                      {t("landing.nav.assessmentLibrary")}
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} md={4} xxl={"auto"}>
                  <Row className={"text-24 mb-3 mt-5 gilroy-bold"}>
                    <Col>{t("landing.footer.legalInfo")}</Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("aydinlatma_metinleri");
                      }}
                    >
                      {t("landing.footer.clarificationTexts")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("bilgi_guvenligi_politikalari");
                      }}
                    >
                      {t("landing.footer.securityPolicies")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("gizlilik_ve_cerezler");
                      }}
                    >
                      {t("landing.footer.privacyCookies")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("sozlesmeler");
                      }}
                    >
                      {t("landing.footer.agreements")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("veri_sahibi_haklari");
                      }}
                    >
                      {t("landing.footer.dataOwnerRights")}
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={"footer-clickable"}
                      onClick={() => {
                        setSelectedKvkkText("acik_riza_metni");
                      }}
                    >
                      {t("landing.footer.explicitConsentTexts")}
                    </Col>
                  </Row>
                </Col>
                {/* <Col xs={12} md={6} xxl={"auto"}>
                <Row className={"text-24 mb-3 mt-5 gilroy-bold"}>
                  <Col>Ödeme Yöntemleri</Col>
                </Row>
                <Row>
                  <Col>Visa</Col>
                </Row>
                <Row>
                  <Col>MasterCard</Col>
                </Row>
                <Row>
                  <Col>PayPal</Col>
                </Row>
              </Col>*/}
                <Col xs={12} md={4} xxl={"auto"}>
                  <Row className={"text-24 mb-3 mt-5 gilroy-bold"}>
                    <Col className={"footer-clickable"}>{t("landing.footer.social")}</Col>
                  </Row>
                  <Row>
                    <Col className={"footer-clickable"}>LinkedIn</Col>
                  </Row>
                  <Row>
                    <Col className={"footer-clickable"}>Instagram</Col>
                  </Row>
                  <Row>
                    <Col className={"footer-clickable"}>X</Col>
                  </Row>
                  <Row>
                    <Col className={"footer-clickable"}>Facebook</Col>
                  </Row>
                  <Row>
                    <Col className={"footer-clickable"}>Youtube</Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className={"justify-content-center "}>
            <Col xs={11} style={{ borderBottom: "1px solid #222222" }}></Col>
          </Row>
          <Row className={"justify-content-end gilroy-thin text-18 text-color-gray-dark me-5 mt-3 mb-4"}>
            <Col xs={"auto"} className={"pe-5"}>
              {t("landing.footer.copyright")}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default LandingPageFooter;
